import styled from 'styled-components'
import { BUTTON_HEIGHTS, MEDIA_QUERIES } from './media-queries'

export const PaypalPreviewButtonUi = styled.div<{
  backgroundColor: string
  borderRadius: number
}>`
    ${MEDIA_QUERIES.SMALLEST_MOBILE} {
        height: ${BUTTON_HEIGHTS.SMALLEST_MOBILE.height};
        min-height: ${BUTTON_HEIGHTS.SMALLEST_MOBILE.minHeight};
        max-height: ${BUTTON_HEIGHTS.SMALLEST_MOBILE.maxHeight};
    }

    ${MEDIA_QUERIES.SMALL_MOBILE} {
        height: ${BUTTON_HEIGHTS.SMALL_MOBILE.height};
        min-height: ${BUTTON_HEIGHTS.SMALL_MOBILE.minHeight};
        max-height: ${BUTTON_HEIGHTS.SMALL_MOBILE.maxHeight};
    }

    ${MEDIA_QUERIES.MEDIUM_MOBILE} {
        height: ${BUTTON_HEIGHTS.MEDIUM_MOBILE.height};
        min-height: ${BUTTON_HEIGHTS.MEDIUM_MOBILE.minHeight};
        max-height: ${BUTTON_HEIGHTS.MEDIUM_MOBILE.maxHeight};
    }

    ${MEDIA_QUERIES.LARGE_MOBILE} {
        height: ${BUTTON_HEIGHTS.LARGE_MOBILE.height};
        min-height: ${BUTTON_HEIGHTS.LARGE_MOBILE.minHeight};
        max-height: ${BUTTON_HEIGHTS.LARGE_MOBILE.maxHeight};
    }

    ${MEDIA_QUERIES.DESKTOP} {
        height: ${BUTTON_HEIGHTS.DESKTOP.height};
        min-height: ${BUTTON_HEIGHTS.DESKTOP.minHeight};
        max-height: ${BUTTON_HEIGHTS.DESKTOP.maxHeight};
    }
    
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
    background-color: ${p => p.backgroundColor};
    border-radius: ${p => `${p.borderRadius}px`};
`
